import { useEffect, useState } from 'react';
import { useSearchParams, Link } from 'react-router-dom';
import { api, formatApiError } from '@/lib/api';
import { CheckCircle2, XCircle, Loader2 } from 'lucide-react';

/**
 * Pagina disiscrizione newsletter one-click (GDPR / CAN-SPAM).
 * Legge ?token=... dall'URL e chiama /api/newsletter/unsubscribe. Non richiede login.
 */
export default function NewsletterUnsubscribe() {
  const [sp] = useSearchParams();
  const token = sp.get('token') || '';
  const [state, setState] = useState('loading');
  const [email, setEmail] = useState('');
  const [err, setErr] = useState('');

  useEffect(() => {
    if (!token) { setState('error'); setErr('Link non valido'); return; }
    api.get('/newsletter/unsubscribe', { params: { token } })
      .then(r => { setState('success'); setEmail(r.data?.email || ''); })
      .catch(e => { setState('error'); setErr(formatApiError(e)); });
  }, [token]);

  return (
    <div className="max-w-xl mx-auto px-4 py-20 text-center" data-testid="newsletter-unsubscribe-page">
      {state === 'loading' && <>
        <Loader2 size={48} className="mx-auto animate-spin text-muted-foreground"/>
        <p className="mt-4 text-muted-foreground">Stiamo elaborando la richiesta…</p>
      </>}
      {state === 'success' && <>
        <div className="inline-flex w-16 h-16 rounded-full bg-muted items-center justify-center">
          <CheckCircle2 size={32} className="text-muted-foreground"/>
        </div>
        <h1 className="font-display text-3xl md:text-4xl tracking-tighter mt-6">Ci siamo. Ciao.</h1>
        <p className="mt-3 text-muted-foreground">
          {email} è stata rimossa dalla newsletter. Non riceverai più comunicazioni promozionali da AgriNexus.
          Continuerai a ricevere solo le email di servizio (es. messaggi, reset password).
        </p>
        <p className="mt-6 text-sm text-muted-foreground">
          Hai cambiato idea? <Link to="/preferenze" className="underline">Riattiva la newsletter</Link> dalle preferenze.
        </p>
      </>}
      {state === 'error' && <>
        <div className="inline-flex w-16 h-16 rounded-full bg-destructive/15 items-center justify-center">
          <XCircle size={32} className="text-destructive"/>
        </div>
        <h1 className="font-display text-3xl tracking-tighter mt-6">Link non valido</h1>
        <p className="mt-3 text-muted-foreground">{err}</p>
      </>}
    </div>
  );
}
